// src/pages/admin/ClusterCreatePage.jsx
import React, { useState, useEffect } from "react";
import axiosInstance from "../../api/axiosInstance";

const ClusterCreatePage = ({ onSuccess }) => {
    const [form, setForm] = useState({
        code: "",
        name: "",
        type: "",
        country_code: "",
        region_id: "",
        url: "",
        is_active: true,
    });
    const [regions, setRegions] = useState([]);
    const [loading, setLoading] = useState(false);

    // fetch regions để fill select
    useEffect(() => {
        const fetchRegions = async () => {
            try {
                const res = await axiosInstance.get("/admin/regions/");
                setRegions(res.data || []);
            } catch (err) {
                console.error("❌ Failed to load regions", err);
            }
        };
        fetchRegions();
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axiosInstance.post("/admin/clusters/", form);
            if (onSuccess) onSuccess(); // refresh list
            setForm({
                code: "",
                name: "",
                type: "",
                country_code: "",
                region_id: "",
                url: "",
                is_active: true,
            });
        } catch (err) {
            console.error("❌ Create cluster failed", err);
            alert("Create cluster failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <h3 className="text-xl font-semibold text-green-400 mb-4">
                Create Cluster
            </h3>
            <div>
                <label className="block text-sm font-medium mb-1">Code</label>
                <input
                    type="text"
                    name="code"
                    value={form.code}
                    onChange={handleChange}
                    className="w-full rounded-lg border-gray-300 px-3 py-2 text-gray-900"
                    required
                />
            </div>

            <div>
                <label className="block text-sm font-medium mb-1">Name</label>
                <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    className="w-full rounded-lg border-gray-300 px-3 py-2 text-gray-900"
                    required
                />
            </div>

            <div>
                <label className="block text-sm font-medium mb-1">Region</label>
                <select
                    name="region_id"
                    value={form.region_id}
                    onChange={handleChange}
                    className="w-full rounded-lg border-gray-300 px-3 py-2 text-gray-900"
                    required
                >
                    <option value="">-- Select Region --</option>
                    {regions.map((r) => (
                        <option key={r.id} value={r.id}>
                            {r.name} ({r.code})
                        </option>
                    ))}
                </select>
            </div>

            <div>
                <label className="block text-sm font-medium mb-1">
                    Country Code
                </label>
                <input
                    type="text"
                    name="country_code"
                    value={form.country_code}
                    onChange={handleChange}
                    className="w-full rounded-lg border-gray-300 px-3 py-2 text-gray-900"
                    placeholder="VN, US..."
                    required
                />
            </div>

            <div>
                <label className="block text-sm font-medium mb-1">URL</label>
                <input
                    type="text"
                    name="url"
                    value={form.url}
                    onChange={handleChange}
                    className="w-full rounded-lg border-gray-300 px-3 py-2 text-gray-900"
                    placeholder="https://..."
                    required
                />
            </div>

            <div>
                <label className="block text-sm font-medium mb-1">End Point Type</label>
                <select
                    name="type"
                    value={form.type}
                    onChange={handleChange}
                    className="w-full rounded-lg border-gray-300 px-3 py-2 text-gray-900"
                    required
                >
                    
                    <option value="">-- Select Region --</option>
                    <option value="PORT">Port (Ex: URL:5000)</option>
                    <option value="Path">Path (Ex: URL/indentity/v3)</option>
                </select>
            </div>

            <div className="flex items-center space-x-2">
                <input
                    type="checkbox"
                    name="is_active"
                    checked={form.is_active}
                    onChange={handleChange}
                    className="h-4 w-4 text-green-600 border-gray-300 rounded"
                />
                <label className="text-sm font-medium">Active</label>
            </div>

            <button
                type="submit"
                disabled={loading}
                className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-semibold"
            >
                {loading ? "⏳ Creating..." : "Create Cluster"}
            </button>
        </form>
    );
};

export default ClusterCreatePage;
